import { useEffect, useState } from 'react'
import { Container, Item } from './styles'
import { IoSettingsSharp } from 'react-icons/io5'
import { RiCamera3Fill, RiFile2Fill, RiHome5Fill, RiSave2Fill } from 'react-icons/ri'
import { BsInfoCircleFill } from 'react-icons/bs'
import { FaVolumeOff, FaVolumeUp } from 'react-icons/fa'
import { useGame } from '../../contexts'
import { t } from '../../adapters/translate/translate'

export type IMenuItemProps = {
  onAction: () => void;
  imageURL: string;
  width?: string;
  height?: string;
  tooltip?: string;
  name?: string;
}

type Props = {
  items: IMenuItemProps[]
  mobile?: boolean
  home?: boolean
}

const MenuIcon = ({ name }:any) => {
  switch (name) {
    case 'menu':
      return <IoSettingsSharp/>
    case 'home':
      return <RiHome5Fill/>
    case 'gallery':
      return <RiCamera3Fill/>
    case 'instructions':
      return <BsInfoCircleFill/>
    case 'soundOn':
      return <FaVolumeUp/>
    case 'soundOff':
      return <FaVolumeOff/>
    case 'recovery':
      return <RiSave2Fill/>
    case 'file':
      return <RiFile2Fill/>
  }
  return null
}

const SideMenu = ({ items, mobile, home }: Props) => {
  const [firstItem, setFirstItem] = useState<IMenuItemProps>({} as IMenuItemProps)
  const [lastItems, setLastItems] = useState<IMenuItemProps[]>([])
  const { game } = useGame()

  function loadItemsConfig () {
    const [first, ...rest] = items
    setFirstItem(first)
    setLastItems(rest)
  }

  useEffect(() => {
    loadItemsConfig()
  }, [items])

  return (
    <Container mobile={mobile} home={home}>
        {!mobile && <Item
          onClick={firstItem.onAction}
          style={{
            padding: 0,
            color: game?.textColor || '#fff'
          }}>
          <IoSettingsSharp/>
        </Item>}
        <section>
          {
            lastItems.map(item => (
              <Item
                key={item.imageURL}
                onClick={item.onAction}
                title={item.tooltip}
                className={item.tooltip === t('Audio: on/off') ? 'sound-icon' : ''}
                style={{ color: game?.textColor || '#fff' }}
              >
                <MenuIcon name={item.name} />
              </Item>
            ))
          }
        </section>
        {mobile && <Item
          onClick={firstItem.onAction}
          style={{
            padding: 0,
            color: game?.textColor || '#fff'
          }} mobile>
          <IoSettingsSharp/>
        </Item>}
    </Container>
  )
}

export default SideMenu
